import React from 'react';
import { GitCommit, GitMerge, MessageSquare, CheckCircle } from 'lucide-react';
interface ActivityItem {
  id: number;
  type: 'commit' | 'merge' | 'comment' | 'release';
  user: string;
  action: string;
  target: string;
  time: string;
  description?: string;
  avatar: string;
}
const activities: ActivityItem[] = [{
  id: 1,
  type: 'release',
  user: 'code-vanta',
  action: 'deployed',
  target: 'fintech-dashboard-v2.0',
  time: '2 hours ago',
  description: 'Production deployment successful. New analytics features are now live for all enterprise users.',
  avatar: 'https://api.dicebear.com/7.x/identicon/svg?seed=code-vanta'
}, {
  id: 2,
  type: 'merge',
  user: 'sarah-dev',
  action: 'merged pull request',
  target: '#42 in e-commerce-platform',
  time: '5 hours ago',
  description: 'Integrated Stripe payment gateway with 3D Secure support.',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=sarah'
}, {
  id: 3,
  type: 'comment',
  user: 'alex-client',
  action: 'commented on',
  target: 'mobile-app-prototype',
  time: 'yesterday',
  description: '"The new user flow is exactly what we were looking for. The animation on the login screen is a nice touch!"',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=alex'
}, {
  id: 4,
  type: 'commit',
  user: 'mike-engineer',
  action: 'pushed to',
  target: 'main',
  time: 'yesterday',
  description: 'feat: optimize database queries for reporting module',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=mike'
}];
export function ActivityFeed() {
  const getIcon = (type: string) => {
    switch (type) {
      case 'commit':
        return <GitCommit size={14} className="text-[#57606a]" data-id="element-18" />;
      case 'merge':
        return <GitMerge size={14} className="text-[#8250df]" data-id="element-19" />;
      case 'comment':
        return <MessageSquare size={14} className="text-[#57606a]" data-id="element-20" />;
      case 'release':
        return <CheckCircle size={14} className="text-[#1a7f37]" data-id="element-21" />;
      default:
        return <GitCommit size={14} data-id="element-22" />;
    }
  };
  return <section className="py-4" data-id="element-23">
      <h2 className="text-sm font-semibold text-[#24292f] mb-4" data-id="element-24">
        Contribution activity
      </h2>

      <div className="relative pl-4 ml-2 border-l border-[#d0d7de] space-y-6" data-id="element-25">
        {activities.map(item => <div key={item.id} className="relative" data-id="element-26">
            {/* Timeline dot */}
            <div className="absolute -left-[25px] top-1 bg-[#f6f8fa] p-1 rounded-full border border-[#d0d7de]" data-id="element-27">
              {getIcon(item.type)}
            </div>

            <div className="flex items-start gap-3" data-id="element-28">
              <div className="flex-1" data-id="element-29">
                <div className="flex items-center gap-2 text-sm mb-1" data-id="element-30">
                  <span className="font-semibold text-[#24292f] hover:text-[#0969da] cursor-pointer hover:underline" data-id="element-31">
                    {item.user}
                  </span>
                  <span className="text-[#57606a]" data-id="element-32">{item.action}</span>
                  <span className="font-semibold text-[#24292f] hover:text-[#0969da] cursor-pointer hover:underline" data-id="element-33">
                    {item.target}
                  </span>
                  <span className="text-xs text-[#57606a] ml-auto" data-id="element-34">
                    {item.time}
                  </span>
                </div>

                {item.description && <div className="mt-1 p-3 bg-white border border-[#d0d7de] rounded-md text-sm text-[#24292f] shadow-sm" data-id="element-35">
                    {item.type === 'comment' && <span className="text-[#57606a] italic mr-1" data-id="element-36">
                        Client said:
                      </span>}
                    {item.description}
                  </div>}
              </div>
            </div>
          </div>)}

        <div className="relative pt-2" data-id="element-37">
          <div className="absolute -left-[25px] top-3 w-2 h-2 bg-[#d0d7de] rounded-full ml-1.5" data-id="element-38"></div>
          <button className="text-xs text-[#0969da] font-semibold hover:underline w-full text-left" data-id="element-39">
            View more activity
          </button>
        </div>
      </div>
    </section>;
}